import { __awaiter } from "tslib";
import React from 'react';
import { useExtensionRegistry } from './extension-context';
export function XFlowAppExtensionModule(props) {
    const { createModule, children } = props;
    /** 获取扩展Registry */
    const extensionRegistry = useExtensionRegistry();
    /** Config */
    const config = React.useMemo(() => props.config || { CONFIG_TYPE: '', getConfig: () => __awaiter(this, void 0, void 0, function* () { return ({}); }) }, 
    /* eslint-disable-next-line  */
    []);
    React.useEffect(() => {
        /** 注册 extension 到 Registry */
        const disposable = extensionRegistry.addExtension({
            config: config,
            createModule,
        });
        return () => {
            disposable.dispose();
        };
        /* eslint-disable-next-line  */
    }, []);
    /** 可以 Wrap Children组件 */
    if (Array.isArray(children) || React.isValidElement(children)) {
        return React.createElement(React.Fragment, null,
            " ",
            children,
            " ");
    }
    return null;
}
//# sourceMappingURL=app-extension-module.js.map